export interface UpdateContactInfoForm {
  phone: string
  email: string
  optIns: {
    terms: boolean
    feedback: boolean
  }
}

export const inputNamePhone = 'input_phone'
export const inputNameEmail = 'input_email'
export const checkboxTerms = 'checkbox_terms'
export const checkboxFeedback = 'checkbox_feedback'
